import React from 'react';

interface PageProps {
  title: string;
  children?: React.ReactNode;
}

const Page: React.FC<PageProps> = ({ title, children }) => {
  React.useEffect(() => {
    const baseTitle = 'Enlo';
    document.title = `${title} - ${baseTitle}`;
  }, [title]);

  return <>{children}</>;
};

export default Page;
